import { useMemo } from 'react'

import { AgBarSeriesOptions, AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface Rebased0ChartProps extends ICReportChartPrimitive {}

export const Rebased0Chart: React.FC<Rebased0ChartProps> = ({ params, options }) => {
  const query = diversifiers.useRebased0Monthly(params)
  const data = query.data ?? []

  const nonDateKeys = Object.keys(data?.[0] ?? {}).filter(
    (key) => !['date', params.fund_name].includes(key),
  )

  const dataFormatted = useMemo(() => {
    return data.map((item: any) => {
      return { ...item, date: new Date(item.date) }
    })
  }, [data])

  const mergedOptions: AgChartOptions = {
    data: dataFormatted,
    height: 400,

    series: [
      ...nonDateKeys.map(
        (key) =>
          ({
            type: 'bar',
            xKey: 'date',
            yKey: key,
            yName: key,
            stackGroup: 'stackgroup',
          }) satisfies AgBarSeriesOptions,
      ),
      {
        type: 'line',
        interpolation: { type: 'smooth' },
        xKey: 'date',
        yKey: params.fund_name!,
        title: 'Total',
        stroke: 'black',
        marker: {
          fill: 'black',
          size: 0,
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        nice: false,
        label: {
          format: '%d %b %Y',
        },
      },
      {
        type: 'number',
        position: 'left',
        label: {
          formatter: (params) => {
            return params.index >= 0
              ? `${params?.value * 100}%`
              : `${(params?.value * 100).toFixed(2)}%`
          },
        },
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
